/**
 * Performance PDP — free member gifts card + modal synced to subscription tier.
 */
(function () {
  function getRoot(el) {
    return (el && el.closest("#product-template")) || document.getElementById("product-template");
  }

  function getActiveGiftTierKey(root) {
    var tier = root.querySelector(
      ".performance-pdp-tier--active[data-performance-pdp-tier][data-gift-tier-key]"
    );
    return tier ? tier.dataset.giftTierKey || "" : "";
  }

  function syncGiftPanels(root) {
    if (!root) return;
    var key = getActiveGiftTierKey(root);
    var panels = root.querySelectorAll("[data-member-gift-panel]");
    if (!panels.length) return;

    panels.forEach(function (panel) {
      var match = panel.dataset.giftTierKey === key;
      if (match) {
        panel.removeAttribute("hidden");
      } else {
        panel.setAttribute("hidden", "");
      }
    });
  }

  function filterModalItems(modal, tierKey) {
    var items = modal.querySelectorAll("[data-gift-tiers]");
    items.forEach(function (item) {
      var tiers = (item.dataset.giftTiers || "").split(/\s+/);
      var show = tiers.indexOf(tierKey) !== -1;
      item.style.display = show ? "" : "none";
    });
  }

  function fillModalFromPanel(modal, panel) {
    if (!modal || !panel) return;

    var headline = modal.querySelector("[data-perf-gift-modal-headline]");
    var intro = modal.querySelector("[data-perf-gift-modal-intro]");
    var footnote = modal.querySelector("[data-perf-gift-modal-footnote]");
    var pill = modal.querySelector("[data-perf-gift-modal-pill]");
    var imageHost = modal.querySelector("[data-perf-gift-modal-image]");

    var h = panel.dataset.modalHeadline || "";
    var v = panel.dataset.modalValue || "";
    var introTpl = panel.dataset.modalIntro || "";
    var foot = panel.dataset.modalFootnote || "";
    var pillText = panel.dataset.modalPill || "FREE GIFTS";

    if (headline) headline.textContent = h;
    if (pill) pill.textContent = pillText;
    if (footnote) footnote.textContent = foot;

    if (intro) {
      var valueHtml = v ? "<strong>" + v + "</strong>" : "";
      intro.innerHTML = introTpl.split("[value]").join(valueHtml);
    }

    if (imageHost) {
      imageHost.innerHTML = "";
      var tpl = panel.querySelector("[data-member-gift-modal-image-template]");
      if (tpl && tpl.content) {
        imageHost.appendChild(tpl.content.cloneNode(true));
      }
    }

    filterModalItems(modal, panel.dataset.giftTierKey || "");
    modal.querySelector("[data-perf-gift-modal-dialog]").setAttribute("data-tier", panel.dataset.giftTierKey || "");
  }

  function openGiftModal(tierKey, root) {
    root = getRoot(root);
    if (!root) return;
    var overlay = root.querySelector("[data-perf-member-gift-modal]");
    if (!overlay) return;

    var panel =
      root.querySelector('[data-member-gift-panel][data-gift-tier-key="' + tierKey + '"]') ||
      root.querySelector("[data-member-gift-panel]:not([hidden])");

    fillModalFromPanel(overlay, panel);
    overlay.classList.add("perf-gift-modal-overlay--open");
    overlay.setAttribute("aria-hidden", "false");
    document.body.classList.add("perf-gift-modal-open");
  }

  function closeGiftModal(root) {
    root = getRoot(root);
    if (!root) return;
    var overlay = root.querySelector("[data-perf-member-gift-modal]");
    if (!overlay) return;
    overlay.classList.remove("perf-gift-modal-overlay--open");
    overlay.setAttribute("aria-hidden", "true");
    document.body.classList.remove("perf-gift-modal-open");
  }

  window.syncPerformanceMemberGifts = syncGiftPanels;

  document.addEventListener("click", function (e) {
    var openBtn = e.target.closest("[data-open-member-gift-modal]");
    if (openBtn) {
      e.preventDefault();
      openGiftModal(openBtn.dataset.giftTierKey || "", openBtn);
      return;
    }

    if (e.target.closest("[data-close-member-gift-modal]")) {
      e.preventDefault();
      closeGiftModal(e.target);
      return;
    }

    var overlay = e.target.closest("[data-perf-member-gift-modal]");
    if (overlay && e.target === overlay) {
      closeGiftModal(overlay);
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    document.querySelectorAll("[data-perf-member-gift-modal].perf-gift-modal-overlay--open").forEach(function () {
      closeGiftModal(document.getElementById("product-template"));
    });
  });

  function boot(root) {
    root = getRoot(root);
    if (!root) return;
    syncGiftPanels(root);
  }

  document.addEventListener("product:flavor-section-swapped", function (ev) {
    var sectionRoot = ev.detail && ev.detail.root;
    window.setTimeout(function () {
      boot(sectionRoot && sectionRoot.querySelector("#product-template"));
    }, 120);
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      boot();
    });
  } else {
    boot();
  }
})();
